import React, { Component } from 'react';

import { Row, Col , Card} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Introduction/Missions.css";

const IntroductionCard ={
    borderRadius:"20px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}

const IntroductionCardHeader={
    fontFamily:"IranSans",
    color:"#174561",
    fontSize:"1.1em",
    paddingRight: "10px",
    paddingTop:"3px"
}
const Goals = props => {
    
     return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
            <Row>
                <Col span={4}></Col>
                <Col span={16}>
                    <div style={IntroductionCard}>
                        <Margin top={5}></Margin>
                        <Row>
                            <Col span={16}>
                                <div style={{backgroundColor:"#f5f5f5" , height:"100%" , borderRadius:"20px 0 0 20px", padding:"30px"}}>
                                     <p className="textParagraph">
                                         •	حل اختلافات بيمه‌اي بين بيمه‌گران و بيمه‌گذاران
                                         <br/>
                                         •	ارائه خدمات با كيفيت به بيمه‌گران و بيمه‌گذاران
                                         <br/>
                                         •	تربيت سرمايه انساني متخصص در حوزه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	ايجاد نوآوري‌هاي بيمه‌اي در زمينه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	كاهش كژمنشي و مخاطرات اخلاقي در قراردادهاي بيمه‌اي بين بيمه‌گران و بيمه‌گذاران
                                         <br />
                                         •	افزايش اعتماد عمومي به نهاد بيمه و توسعه صنعت بيمه
                                         <br />
                                         •	اشاعه دانش ضمني در حوزه ارزيابي خسارت‌هاي بيمه‌اي در سطح جامعه
                                         <br />
                                         •	استانداردسازي كار كارشناسي در حوزه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	كمك به اجراي مناسب سياستگذاري‌هاي بيمه‌اي
                                         <br />
                                         •	انتقال تجارب و مسائل حوزه ارزيابي خسارت به نهاد قانونگذاري براي قانون‌گذاري‌هاي بهتر
                                         <br />
                                         •	توسعه حرفه و تخصص ارزيابي خسارت‌هاي بيمه‌اي براي توسعه بازار بيمه در كشور
                                         <br />
                                         •	تقويت شفافيت و پاسخگويي در بازار بيمه براي افزايش اعتماد عمومي به صنعت بيمه
                                         <br />
                                         •	راه‌اندازي بانک آمار و اطلاعات بيمه‌اي براي توسعه تحقيقات در مورد مسائل بيمه‌اي
                                         <br />
                                         •	ثبت، انباشت و دسته‌بندي دانش ضمني متخصصان و كارشناسان ارزيابي خسارت
                                         <br />
                                         •	تسهيم و برهم افزايي دانش ارزيابي خسارت در راستاي تقويت صنعت بيمه كشور
                                         <br />
                                         •	توسعه و تقويت گفت‌وگوهاي بيمه‌اي در بين شركت‌هاي بيمه 
                                         <br />
                                         •	توسعه رقابت توام با همكاري در بين شركت‌هاي ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	تقويت انجمن حرفه‌اي مردم‌نهاد ارزيابي خسارت‌هاي بيمه‌اي

                                    </p>
                                </div>
                            </Col>
                            <Col span={8} style={{direction:"rtl" , textAlign:"right"}}>
                                 <div className="miniCardTitleBorder" style={{
                                     position: 'absolute', left: '50%', top: '50%',
                                     transform: 'translate(-50%, -50%)'
                                 }}>
                                    <p className="miniCardTitle"><strong>اهداف ما</strong></p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={4}></Col>
            </Row>
        </div>
     ) : props.size === "tablet" ? (
             <div>
                 <Row>
                     <Col span={2}></Col>
                     <Col span={20}>
                         <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                             <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                 <Center>
                                     <Margin top={4}>
                                         <div>
                                             <p className="cardTitleTablet"><strong>اهداف ما</strong></p>
                                         </div>
                                     </Margin>
                                 </Center>
                                 <Center>
                                     <hr className="cardTitleHRTablet" />
                                 </Center>
                                 <Margin top={2}></Margin>
                                 <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                     <p className="textParagraphTablet" style={{ paddingTop: "10px" }}>
                                         •	حل اختلافات بيمه‌اي بين بيمه‌گران و بيمه‌گذاران
                                         <br />
                                         •	ارائه خدمات با كيفيت به بيمه‌گران و بيمه‌گذاران
                                         <br />
                                         •	تربيت سرمايه انساني متخصص در حوزه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	ايجاد نوآوري‌هاي بيمه‌اي در زمينه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	كاهش كژمنشي و مخاطرات اخلاقي در قراردادهاي بيمه‌اي بين بيمه‌گران و بيمه‌گذاران
                                         <br />
                                         •	افزايش اعتماد عمومي به نهاد بيمه و توسعه صنعت بيمه
                                         <br />
                                         •	اشاعه دانش ضمني در حوزه ارزيابي خسارت‌هاي بيمه‌اي در سطح جامعه
                                         <br />
                                         •	استانداردسازي كار كارشناسي در حوزه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	كمك به اجراي مناسب سياستگذاري‌هاي بيمه‌اي
                                         <br />
                                         •	انتقال تجارب و مسائل حوزه ارزيابي خسارت به نهاد قانونگذاري براي قانون‌گذاري‌هاي بهتر
                                         <br />
                                         •	توسعه حرفه و تخصص ارزيابي خسارت‌هاي بيمه‌اي براي توسعه بازار بيمه در كشور
                                         <br />
                                         •	تقويت شفافيت و پاسخگويي در بازار بيمه براي افزايش اعتماد عمومي به صنعت بيمه
                                         <br />
                                         •	راه‌اندازي بانک آمار و اطلاعات بيمه‌اي براي توسعه تحقيقات در مورد مسائل بيمه‌اي
                                         <br />
                                         •	ثبت، انباشت و دسته‌بندي دانش ضمني متخصصان و كارشناسان ارزيابي خسارت
                                         <br />
                                         •	تسهيم و برهم افزايي دانش ارزيابي خسارت در راستاي تقويت صنعت بيمه كشور
                                         <br />
                                         •	توسعه و تقويت گفت‌وگوهاي بيمه‌اي در بين شركت‌هاي بيمه
                                         <br />
                                         •	توسعه رقابت توام با همكاري در بين شركت‌هاي ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	تقويت انجمن حرفه‌اي مردم‌نهاد ارزيابي خسارت‌هاي بيمه‌اي

                                </p>
                                 </div>
                             </div>
                         </div>
                     </Col>
                     <Col span={2}></Col>
                 </Row>
             </div>

     ) : (
            <div>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                     <Center>
                                         <Margin top={4}>
                                             <div>
                                                 <p className="cardTitleMobile"><strong>اهداف ما</strong></p>
                                             </div>
                                         </Margin>
                                     </Center>
                                     <Center>
                                         <div className="cardTitleHR"></div>
                                     </Center>
                                     <Margin top={2}></Margin>
                                <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                <p className="textParagraphMobile" style={{ paddingTop: "10px" }}>
                                             •	حل اختلافات بيمه‌اي بين بيمه‌گران و بيمه‌گذاران
                                         <br />
                                         •	ارائه خدمات با كيفيت به بيمه‌گران و بيمه‌گذاران
                                         <br />
                                         •	تربيت سرمايه انساني متخصص در حوزه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	ايجاد نوآوري‌هاي بيمه‌اي در زمينه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	كاهش كژمنشي و مخاطرات اخلاقي در قراردادهاي بيمه‌اي بين بيمه‌گران و بيمه‌گذاران
                                         <br />
                                         •	افزايش اعتماد عمومي به نهاد بيمه و توسعه صنعت بيمه
                                         <br />
                                         •	اشاعه دانش ضمني در حوزه ارزيابي خسارت‌هاي بيمه‌اي در سطح جامعه
                                         <br />
                                         •	استانداردسازي كار كارشناسي در حوزه ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	كمك به اجراي مناسب سياستگذاري‌هاي بيمه‌اي
                                         <br />
                                         •	انتقال تجارب و مسائل حوزه ارزيابي خسارت به نهاد قانونگذاري براي قانون‌گذاري‌هاي بهتر
                                         <br />
                                         •	توسعه حرفه و تخصص ارزيابي خسارت‌هاي بيمه‌اي براي توسعه بازار بيمه در كشور
                                         <br />
                                         •	تقويت شفافيت و پاسخگويي در بازار بيمه براي افزايش اعتماد عمومي به صنعت بيمه
                                         <br />
                                         •	راه‌اندازي بانک آمار و اطلاعات بيمه‌اي براي توسعه تحقيقات در مورد مسائل بيمه‌اي
                                         <br />
                                         •	ثبت، انباشت و دسته‌بندي دانش ضمني متخصصان و كارشناسان ارزيابي خسارت
                                         <br />
                                         •	تسهيم و برهم افزايي دانش ارزيابي خسارت در راستاي تقويت صنعت بيمه كشور
                                         <br />
                                         •	توسعه و تقويت گفت‌وگوهاي بيمه‌اي در بين شركت‌هاي بيمه
                                         <br />
                                         •	توسعه رقابت توام با همكاري در بين شركت‌هاي ارزيابي خسارت‌هاي بيمه‌اي
                                         <br />
                                         •	تقويت انجمن حرفه‌اي مردم‌نهاد ارزيابي خسارت‌هاي بيمه‌اي

                                </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={2}></Col>
                </Row>
            </div>
                     
          );
};

export default Goals;
